import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { EOtpremnicaDto, EOtpremniceClient } from '@kodit/core/data-api';
import { AlertService, BaseService } from '@kodit/core/services';
import { EMPTY, Observable } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EotpremnicaIzPredracunaResolver
  extends BaseService
  implements Resolve<EOtpremnicaDto> {
  constructor(
    private _client: EOtpremniceClient,
    private _alertService: AlertService
  ) {
    super();
  }

  resolve(route: ActivatedRouteSnapshot): Observable<EOtpremnicaDto> {
    const predracunId = Number.parseInt(route.paramMap.get('predracunId') ?? '');
    return this._client.getNewEOtpremnicaForPredracun(predracunId).pipe(
      mergeMap((res) => {
        if (!res.succeeded) {
          // predracun nije validan za eOtpremnicu - ostajemo na predracunu i prikazujemo sta nedostaje
          this._alertService.addWarnMsgs(res.messages ?? []);
          return EMPTY;
        }

        if (res.messages?.length) {
          this._alertService.addWarnMsgs(res.messages);
        }

        return [this._bezPodrazumevanihVrednosti(res.data)];
      }),
      catchError(this.handleError)
    );
  }

  /**
   * Datumi isporuke i nacin otpreme se unose rucno, a backend za njih vraca podrazumevanu vrednost.
   * Nacin otpreme mora ostati prazan kao kod novog unosa - tek izborom nacina otpreme forma dodaje
   * fazu voznje (ili licni nacin otpreme), bez cega slanje na SEF puca
   */
  private _bezPodrazumevanihVrednosti(dto: EOtpremnicaDto): EOtpremnicaDto {
    const otpremnica = dto as any;
    otpremnica.stvarniDatum = undefined;
    otpremnica.planiraniDatumPocetka = undefined;
    otpremnica.planiraniDatumZavrsetka = undefined;
    otpremnica.nacinOtpreme = undefined;
    return otpremnica;
  }
}
